
import { Link } from 'react-router-dom';

export default function ProcessSection() {
  const processSteps = [
    {
      number: 1,
      title: 'تحليل المتطلبات',
      description: 'دراسة شاملة لاحتياجات المشروع ومتطلبات العميل',
      icon: 'ri-search-line'
    },
    {
      number: 2,
      title: 'التخطيط والجدولة',
      description: 'وضع خطة تنفيذ مفصلة وجدولة زمنية دقيقة',
      icon: 'ri-calendar-line'
    },
    {
      number: 3,
      title: 'التوريد والاعتمادات',
      description: 'توريد المواد والحصول على التراخيص اللازمة',
      icon: 'ri-truck-line'
    },
    {
      number: 4,
      title: 'التنفيذ الموقعي',
      description: 'البدء في تنفيذ المشروع مع مراقبة الجودة',
      icon: 'ri-tools-line'
    },
    {
      number: 5,
      title: 'التسليم والتوثيق',
      description: 'تسليم المشروع المكتمل مع التوثيق الشامل',
      icon: 'ri-file-check-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2B2C2E] mb-6">كيف نعمل؟</h2>
          <p className="text-xl text-[#595A5C] max-w-3xl mx-auto">
            منهجية عمل متكاملة تضمن تحقيق أفضل النتائج وتسليم المشاريع وفق أعلى المعايير
          </p>
        </div>
        
        {/* Desktop Timeline */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-[#F7F7F7] transform -translate-y-1/2"></div>
            <div className="absolute top-1/2 left-0 h-1 bg-[#E71B25] transform -translate-y-1/2 w-full"></div>
            
            {/* Process Steps */}
            <div className="relative flex justify-between items-center">
              {processSteps.map((step, index) => (
                <div key={index} className="flex flex-col items-center group">
                  {/* Step Circle */}
                  <div className="w-20 h-20 bg-[#E71B25] rounded-full flex flex-col items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300 relative z-10">
                    <i className={`${step.icon} text-white text-2xl mb-1`}></i>
                    <span className="text-white text-xs font-bold">{step.number}</span>
                  </div>
                  
                  {/* Step Content */}
                  <div className="text-center max-w-48">
                    <h3 className="text-lg font-bold text-[#2B2C2E] mb-3 leading-tight">
                      {step.title}
                    </h3>
                    <p className="text-[#595A5C] text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Timeline */}
        <div className="lg:hidden">
          <div className="relative">
            {/* Vertical Timeline Line */}
            <div className="absolute right-6 top-0 bottom-0 w-1 bg-[#E71B25]"></div>
            
            {/* Process Steps */}
            <div className="space-y-12">
              {processSteps.map((step, index) => (
                <div key={index} className="flex items-start">
                  {/* Step Circle */}
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center ml-6 flex-shrink-0 shadow-lg relative z-10">
                    <span className="text-white text-sm font-bold">{step.number}</span>
                  </div>
                  
                  {/* Step Content */}
                  <div className="flex-1">
                    <div className="flex items-center mb-3">
                      <div className="w-10 h-10 bg-[#F7F7F7] rounded-xl flex items-center justify-center ml-3">
                        <i className={`${step.icon} text-[#E71B25] text-lg`}></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#2B2C2E]">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-[#595A5C] leading-relaxed mr-13">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16">
          <Link to="/contact">
            <span className="inline-flex items-center justify-center px-8 py-4 bg-[#E71B25] text-white rounded-lg font-medium text-lg hover:bg-[#d11620] transition-all duration-300 shadow-sm hover:shadow-md whitespace-nowrap cursor-pointer">
              طلب اجتماع تقني
              <i className="ri-calendar-check-line mr-3"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
